import { render, staticRenderFns } from "./TraceabilityProgressBar.vue?vue&type=template&id=638ccccc&scoped=true"
import script from "./TraceabilityProgressBar.vue?vue&type=script&lang=js"
export * from "./TraceabilityProgressBar.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityProgressBar.vue?vue&type=style&index=0&id=638ccccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ccccc",
  null
  
)

export default component.exports